import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import mention from "./modules/mentions";
import sentiment from "./modules/sentiments";
import monitors from './modules/monitor';
import users from './modules/users';
import organizations from './modules/organizations';
import comparison from './modules/comparison';
import audience from './modules/audience';
import error from './modules/error';
import platform from './modules/platform';
import moment from 'moment'
import NamedRegExp from 'named-regexp-groups';
import httpClient from "../api/config";
import _keyBy from 'lodash/keyBy';
import _chunk from 'lodash/chunk';
import _isEmpty from "lodash/isEmpty";

Vue.use(Vuex);
Vue.config.devtools = true
let store = new Vuex.Store({
	modules: {
		mention,
		sentiment,
		monitors,
		users,
		organizations,
		comparison,
		audience,
		error,
		platform
	},

	state: {
		accessToken: "",
		selectedDate: [
			//moment().subtract(3,'month').utc().format('YYYY-MM-DD'),
			moment().subtract(3,'month').format('YYYY-MM-DD'),
			moment().format('YYYY-MM-DD')
		],
		monitorActionReady: true,
		selectedMonitorComments: [],
		monitor: {},
		sidebarMonitor: [],
		monitorsInfo: {},
		allAvailableMonitors: [],
		organizationFilterList: [],
		organizationIndexList: {},
		facebookSummary: {
			facebook_mentions_by_keywords:{},
			fbcomments:{
				tags_cloud_data:[],
				category_range: []
			},
			fbposts:{},
			reactions:{
				count:{},
				range_count:[]
			},
			interactions:[],
			posts_count:{watch_count:0, unwatch_count:0}
		},
		previousRoute: undefined,
		monitorAllFetchReady: false,
		organizationAllFetchReady: false,
		userAllFetchReady: false,
		engagementStats: {},
		engagementReady: false,
		commentsCount: {
			trash_count:0,
			inbox_count:0,
		},
		emojiFilterList:[],
		authorizedUserOrganization:{},
		alertStatus: false,
		alertMessage:"",
		alertColor:"",
		alertIcon:"fas fa-check",
	},

	actions: {
		fetchAccessToken({commit}, {code}) {
			return axios.post(`${process.env.VUE_APP_URL}/oauth2/token`, {
				"grant_type": "authorization_code",
				"code": code,
				"redirect_uri": `${process.env.VUE_APP_REDIRECT_URL}/authorizing`,
				"client_id": process.env.VUE_APP_CLIENT_ID,
				"client_secret": process.env.VUE_APP_CLIENT_SECRET
			}).then(({data}) => {
				this._vm.$session.set('rtoken_expire_time', data.refresh_token_expires_at)
				this._vm.$session.set('atoken_expire_time', data.access_token_expires_at)
				this._vm.$session.set('accessToken', data.access_token)
				this._vm.$session.set('refreshToken', data.refresh_token)
			})
		},

		refreshAccessToken() {
			return axios.post(`${process.env.VUE_APP_URL}/oauth2/token`, {
				"grant_type": "refresh_token",
				"refresh_token": this._vm.$session.get('refreshToken'),
				"client_id": process.env.VUE_APP_CLIENT_ID,
				"client_secret": process.env.VUE_APP_CLIENT_SECRET
			}).then(({data}) => {
				this._vm.$session.set('rtoken_expire_time', data.refresh_token_expires_at)
				this._vm.$session.set('atoken_expire_time', data.access_token_expires_at)
				this._vm.$session.set('accessToken', data.access_token)
				this._vm.$session.set('refreshToken', data.refresh_token)
			})
		},

		fetchUser() {
			return httpClient.get(`/oauth2/user`).then(({data}) => {
				this._vm.$session.set('authUser', data)
			})
		},

		fetchAuthorizedUserOrg({commit}) {
			return httpClient.get('/v2/user/organization').then(({data}) => {
				commit('setAuthorizedUserOrganization', data);
			})
		},

		fetchSidebarMonitors({commit}) {
			return httpClient.get(`/v2/monitor/sidebar-monitors`).then(({data:{sidebar_monitors}}) => {
				commit('setSideBarMonitor', sidebar_monitors)
			})
		},

		fetchMonitor({commit}, {monitor_uuid, type='setMonitor'}) {
			return httpClient.get(`/v2/monitor/${monitor_uuid}`)
				.then(({data}) => {
				commit({type, data})
			})
		},

		fetchMonitors({commit}, {page = 1, organization_uuid = undefined, search=undefined, filterPurpose = false}) {
			return httpClient.get('/v2/monitor', {
				params:{organization_uuid, page, search}
			}).then(({data}) => {
				if(!filterPurpose) commit('setMonitors', data);
				else return data;
			});
		},

		fetchOrganizationFilterList({commit}) {
			return httpClient.get(`/v2/organization/filter-list`)
				.then(({data:{organizations}}) => {
					commit('setOrganizationFilterList', organizations);
					commit('setOrganizationIndexList', organizations);
				})
		},

		fetchFacebookSummary({commit}, {monitor_uuid, timerange, type = 'setFacebookSummary'}) {
			return httpClient.post(`/elastic/monitor/${monitor_uuid}/facebook/summary`, {timerange})
				.then(({data}) => {
					commit({type, data});
					commit({
						type:'setSummaryCommentCount',
						data: data.comments_count
					});
					commit({
						type:'setEmojiFilterList',
						data: data.fbcomments.emoji_cloud_data
					})
				})
		},

		createCommentTags({commit}, data) {
			return httpClient.post(`/elastic/monitor/comment/tag`, data)
				.then(({data}) => {
					/*  backend service required this condition.
						if you want to remove this condition plz discuss with backend engineer
					 */
					if (data.success && data.success.message !== "Successfully Updated Tags") {
						commit('error/setErrorDialogStatus', true, {root: true});
						commit('error/setErrorDialogMessage', data.message, {root: true})
					}
					return data;
				}).catch(err => {
					commit('error/setErrorDialogStatus', true, {root: true});
					commit('error/setErrorDialogMessage', "Error occur when adding new tag to comments.", {root:true});
					return Promise.reject(err);
				})
		},

		updateCommentSentiment(context, data) {
			return httpClient.post(`/elastic/monitor/comment/sentiment`, data)
		},

		logout() {
			return httpClient.post(`/logout`);
		},

		generateReport(context, {data, type}) {
			return httpClient.post(`/v2/monitor/download-report/${type}`, data, {
				responseType: 'blob'
			})
		},

		getAccessToken() {
			return this._vm.$session.get("accessToken")
		},

		fetchAllResource({dispatch, commit}, {resourceType, resourceAction}){
			commit(`set${resourceType}AllFetchReady`, false)
			return dispatch(resourceAction)
				.then(({total_page, current_page, ...resource}) => {
					return Promise.all((new Array(total_page-1)).fill(undefined).map((v,index)=>{
						return dispatch(resourceAction, index+2);
					})).then(data => {
						commit(`set${resourceType}AllFetchReady`, true);
						data.push({total_page, current_page, ...resource});
						return data.map(({total_page, current_page, ...resource})=> {
							return Object.values(resource)[0];
						}).reduce((cur, car) => {
							return [].concat(cur, car);
						});
					})
				})
		},

		fetchEngagementStats({commit},data){
			return httpClient.post(`/elastic/monitor/engagement-stats`, data)
				.then(({data})=>{
				commit('setEngagementStats', data)
			})
		},

		changePassword(context, data){
			return httpClient.post(`/change-password`, data)
		}

	},
	mutations: {
		setAccessToken(state, token) {
			state.accessToken = token
		},

		setSideBarMonitor(state, sidebar_monitor) {
			state.sidebarMonitor = sidebar_monitor
		},

		setMonitor(state, payload){
			state.monitor = payload.data;
		},

		setMonitors(state, monitors) {
			state.monitorsInfo = monitors
		},

		setSelectedDates(state, dates) {
			state.selectedDate = dates
		},

		setFacebookSummary(state, payload) {
			state.facebookSummary = payload.data;
		},

		setOrganizationFilterList(state, organizations) {
			state.organizationFilterList = organizations
		},

		setOrganizationIndexList(state, organizations) {
			state.organizationIndexList = _keyBy(organizations, 'uuid');
		},

		setSelectedMonitorComments(state, comment){
			state.selectedMonitorComments = comment;
		},

		setPreviousRoute(state, route){
			state.previousRoute = route
		},

		setMonitorActionReady(state, status) {
			state.monitorActionReady = status;
		},

		setAllAvailableMonitors(state, monitors){
			state.allAvailableMonitors = monitors
		},

		setMonitorAllFetchReady(state, status){
			state.monitorAllFetchReady = status
		},

		setUserAllFetchReady(state, status){
			state.userAllFetchReady = status
		},

		setOrganizationAllFetchReady(state, status){
			state.organizationAllFetchReady = status
		},

		setEngagementStats(state, data){
			state.engagementStats = data;
		},

		setEngagementReady(state, status){
			state.engagementReady = status;
		},

		setSummaryCommentCount(state, payload){
			state.commentsCount = payload.data;
		},

		setEmojiFilterList(state, {data}){
			state.emojiFilterList = data;
		},

		setAuthorizedUserOrganization(state, organization){
			state.authorizedUserOrganization = organization;
		},

		setAlertStatus(state, status){
			state.alertStatus = status
		},

		setAlertMessage(state, msg){
			state.alertMessage = msg
		},

		setAlertIcon(state, icon){
			state.alertIcon = icon
		},

		setAlertColor(state, color){
			state.alertColor = color
		}

	},

	getters:{
		facebookPagesAndCount:(state,_,rootState) => (sourceFrom) => {
			let pageFilter = [];
			let source = state.facebookSummary[sourceFrom] || {};
			let page_id = source.page_id || [];
			let {monitorFanCount} = rootState.mention;
			_chunk(page_id, 2).sort((a, b) => b[1] - a[1]).map(pgid => {
				if (pgid[1] !== 0) {
					let res = {...monitorFanCount.find(fcount => fcount.id === pgid[0])};
					if (res && !_isEmpty(res)) {
						res.count = pgid[1];
						pageFilter.push(res)
					}
				}
			})
			return pageFilter;
		}
	}
});

export default store
